import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['showSidePanel']),
  },
  mounted() {
    if (this.showSidePanel) {
      this.$root.$emit('bv::toggle::collapse', 'sidebar');
    }
  },
};
